export default interface PriceHistoryInterface {
    trend: Trend;
    average: number;
    min: number;
    max: number;
    dailyPrices: DailyPricesInterface[];
}

export interface DailyPricesInterface {
    day: string;
    price: number;
}

export enum Trend {
    constant = 'constant',
    increase = 'increase',
    decrease = 'decrease'
}
